import {
    MessagePart,
    InfoBarCustomAction,
    InfoBarShowDetailsAction,
    InfoBarCalloutAction,
    InfoBarOptionsAction,
} from '../schema/InfoBarMessageViewState';

/**
 * user-defined type guards to check whether messagePart
 * is of InfoBarCustomAction type or not
 */
export const isMessagePartCustomAction = (
    messagePart: MessagePart
): messagePart is InfoBarCustomAction => {
    return !!(<InfoBarCustomAction>messagePart).action;
};

export const isMessagePartShowDetailsAction = (
    messagePart: MessagePart
): messagePart is InfoBarShowDetailsAction => {
    return !!(<InfoBarShowDetailsAction>messagePart).showDetailsText;
};

export const isMessagePartCalloutAction = (
    messagePart: MessagePart
): messagePart is InfoBarCalloutAction => {
    return !!(<InfoBarCalloutAction>messagePart).calloutContent;
};

export const isMessagePartOptionsAction = (
    messagePart: MessagePart
): messagePart is InfoBarOptionsAction => {
    return !!(<InfoBarOptionsAction>messagePart).options;
};
